// GENERATED CODE - DO NOT EDIT
export const PatientTaskTypeMap = {
    CONFIRM_SHIPMENT: 'CONFIRM_SHIPMENT',
    NEEDS_INSURANCE: 'NEEDS_INSURANCE',
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD',
    NEW_YEAR_INSURANCE: 'NEW_YEAR_INSURANCE',
};
//# sourceMappingURL=patient_task_type.js.map